import { ChevronDown, TriangleAlert } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { Button } from '@/components/ui/button'
import type { Problem } from './model'

interface Props {
    problems: Problem[]
    onJump: (p: Problem) => void
}

/** Collapsible list of everything blocking publish. Items that map to a field/page are clickable. */
export default function ProblemsPanel({ problems, onJump }: Props) {
    if (problems.length === 0) return null
    return (
        <Collapsible>
            <Alert variant="destructive">
                <TriangleAlert />
                <AlertTitle className="flex items-center justify-between gap-2">
                    <span>Problems ({problems.length})</span>
                    <CollapsibleTrigger asChild>
                        <Button variant="ghost" size="xs" className="group/problems">
                            Show details <ChevronDown data-icon="inline-end" className="transition-transform group-data-[state=open]/problems:rotate-180" />
                        </Button>
                    </CollapsibleTrigger>
                </AlertTitle>
                <AlertDescription>
                    The form cannot be published until these are fixed.
                    <CollapsibleContent>
                        <ul className="mt-2 flex max-h-56 flex-col gap-1 overflow-y-auto">
                            {problems.map((p, i) => (
                                <li key={i}>
                                    {p.pageId ? (
                                        <button type="button" onClick={() => onJump(p)} className="rounded-sm text-left underline underline-offset-2 outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
                                            {p.message}
                                        </button>
                                    ) : p.message}
                                </li>
                            ))}
                        </ul>
                    </CollapsibleContent>
                </AlertDescription>
            </Alert>
        </Collapsible>
    )
}
